import { QueryClient } from "@tanstack/react-query";
import { ERROR_CODE } from "@repo/api/const";

/** 全局默认 staleTime：同一资源 30s 内多处挂载 / 切回窗口不重复请求。 */
export const DEFAULT_STALE_TIME = 30_000;

/**
 * 只有 http 层包装出来的网络异常 / 超时（status === -1）才值得重试。
 * 业务错误（400 参数、4001 登录失效、567 限频等）重试只会放大问题。
 */
export function isRetryableError(error: unknown): boolean {
  const status = (error as { status?: number } | null)?.status;
  return status === ERROR_CODE.ERROR;
}

/**
 * 三端共用的 QueryClient 工厂。
 * 各应用在入口处 `createQueryClient()` 一次，交给 `QueryClientProvider`，并在登出时 `clear()`。
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: DEFAULT_STALE_TIME,
        retry: (failureCount, error) => isRetryableError(error) && failureCount < 2,
      },
      mutations: {
        retry: 0,
      },
    },
  });
}
